<template>
  <section class="terms-page">
    <PageTitle title="TERMS OF SERVICE"></PageTitle>
    <!-- end of header -->
    <Terms></Terms>
  </section>
</template>
<script>
import Terms from "@/components/Terms/Terms";
import PageTitle from "@/components/PageTitle/PageTitle";

export default {
  components: {
    Terms,
    PageTitle
  }
};
</script>
